import AppModal from "@/components/AppModal";
import {
  ToggleButton,
  ToggleButtonGroup, toggleButtonGroupClasses, toggleButtonClasses, Box,
  Stack, Typography, styled, createStyles, IconButton
} from '@mui/material'

import {getIncreasingDecreasing, isEmptyString} from "@/utils/utils";
import React, {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {setCardPin, modofyCardPin} from '@/services'
import {useNavigate} from "react-router-dom";
import RpIcon, {RpIconColor} from "@/components/RpIcon";
import PinInput from '@/pages/card/components/PinInput/PinInput'

import {getSequenceRepeatCharactar} from '@/utils/utils'
import classes from './CardPinDialog.module.css'
import {useBoolean, useRequest} from "ahooks";
import AppLoadingButton from "@/components/mui/LoadingButton";
import {enqueueSnackbar} from "notistack";
import TwoFAModal from "@/components/TwoFAModal";
import {clearTaskRule, setTaskRuleParams} from "@/redux/slices/user";
import {VerifyAction} from "@/constant/VerifyConstant";

interface CardPinDialogProps {
  open: boolean;
  onClose: () => void;
  card: any
}

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({theme}) => {
  return {
    justifyContent: 'center',
    [`& .${toggleButtonGroupClasses.grouped}`]: {
      border: 'none',
      borderRadius: '36px',
      padding: '3px 20px',
      [`& .MuiTypography-root`]: {
        fontSize: '12px',
      }
    },
    '& .MuiBox-root': {
      borderRadius: '36px',
      backgroundColor: theme.palette.background.default,
    },
    [`& .${toggleButtonGroupClasses.firstButton}`]: {
      borderRadius: '36px',
      // borderBottomLeftRadius: '36px',
    },
    // [`& .${toggleButtonGroupClasses.selected}`]: {
    //     backgroundColor: theme.palette.background.paper,
    // },
  }
})
const CardPinDialog = (props: CardPinDialogProps) => {
  const {t} = useTranslation()
  const {card, onClose, open} = props;
  const navigate = useNavigate();
  const [pinType, setPinType] = useState(4)
  const [pin, setPin] = useState('');
  const [twoFAModalShow , twoFAModalShowOperate] = useBoolean(false);

  const modofyCardPinReq = useRequest(async () => {
    let res = await modofyCardPin(card.cardId, pin)
    return res
  }, {
    manual: true,
  });

  const doModifyPin = () => {
    modofyCardPinReq.runAsync().then(res => {
      enqueueSnackbar(t('set_card_pin_success'), { variant: 'success' })
      onClose && onClose()
    })
    // if (!getIncreasingDecreasing(pin, pinType)) {
    //   enqueueSnackbar('Increasing or Decreasing repeat Or sequence repeat charactar detected', {variant: 'error'})
    //   return
    // }
    // clearTaskRule()
    // if (!card.pinSet) {
    //   setTaskRuleParams(({
    //     action: VerifyAction.PIN_CODE_SET,
    //   }))
    // } else {
    //   setTaskRuleParams(({
    //     action: VerifyAction.PIN_CODE_UPDATE,
    //   }))
    // }
    // twoFAModalShowOperate.setTrue()
    // debugger
    // if (getIncreasingDecreasing(pin, pinType)) {
    //     enqueueSnackbar('Increasing or Decreasing repeat charactar detected', { variant: 'error' })
    //     return
    // }


  }

  const onPinTypeChange = (event, newPinType) => {
    setPin('')
    if (newPinType !== null) {
      setPinType(newPinType);
    }
  }

  return (<>
    <AppModal open={open} onClose={onClose} titleCenter>
      <Box className={classes.modalContent}>
        <Stack direction="row" className={classes.modalHeader}>
          <StyledToggleButtonGroup
            value={pinType}
            exclusive
            onChange={onPinTypeChange}
            className={classes.typeToggle}
          >
            <Box>
              <ToggleButton value={4}>
                <Typography>{t('digit_variable', { count: 4 })}</Typography>
              </ToggleButton>
              <ToggleButton value={6}>
                <Typography>{t('digit_variable', { count: 6 })}</Typography>
              </ToggleButton>
            </Box>
          </StyledToggleButtonGroup>
          <IconButton onClick={onClose}>
            <RpIcon icon={'close'} size={22} color={RpIconColor.MAIN}/>
          </IconButton>
        </Stack>
        <Stack direction="row" gap={'6px'} className={'alert-warm-info'} sx={{marginTop:'25px'}}>
          <RpIcon icon="info" size={16} color="inherit"/>
          <Typography className={classes.tipText}>{t('card_pin_format_helper')}</Typography>
        </Stack>
        <Box className={classes.pinWrap}>
          <Typography className={classes.pinWrapLabel}>{t('card_pin')}</Typography>
          <Stack className={classes.pinInputWrap}>
            <PinInput separator={null} value={pin} onChange={setPin} length={pinType}/>
          </Stack>
        </Box>
        <AppLoadingButton disabled={pin.length < pinType} loading={modofyCardPinReq.loading} variant="contained" fullWidth
                       onClick={() => {
                         doModifyPin()
                       }}>
          {t("confirm")}
        </AppLoadingButton>
      </Box>
    </AppModal>
    <TwoFAModal successCallback={() => {   }} open={twoFAModalShow} onClose={twoFAModalShowOperate.setFalse} />
  </>)
}

export default CardPinDialog;